import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";

import LayoutPro from "./layoutPro";
import Checkbox from "../../components/inputs/checkbox";
import { create } from "../../services/services";
import ModalTwyny from "../../components/modalTwyny";
import LocationAutocomplete from "../../components/LocationAutocomplete";
import { useLoadScript } from "@react-google-maps/api";
import { getMyEtablissement } from "../../store/slices/etablissementSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";



const libraries = ["places"];

// Initial form values from localStorage
const getInitialValues = () => {

  const billingAdress = JSON.parse(localStorage.getItem("adresse_facturation")) || {};
  return {
    numero_rue: billingAdress.numero_rue || "",
    complement_adresse: billingAdress.complement_adresse || "",
    ville: billingAdress.ville || "",
    code_postal: billingAdress.code_postal || "",
    lat: null,
    lng: null,
    saveBellingAdress: billingAdress.saveBellingAdress || false,
    acceptContrat: false,
  };
};

// Validation schema
const validationSchema = Yup.object().shape({
  numero_rue: Yup.string().required("Le numéro et nom de rue sont requis"),
  ville: Yup.string().required("La ville est requise"),
  code_postal: Yup.string()
    .required("Le code postal est requis")
    .matches(/^\d{5}$/, "Le code postal doit contenir 5 chiffres"),
  acceptContrat: Yup.boolean()
    .oneOf([true], "Vous devez accepter le contrat d'utilisation")
    .required("L'acceptation du contrat est obligatoire"),
});

function BillingAddress() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch=useDispatch()
  const {selectedEtablissement}=useSelector((state)=>state.etablissements)
  const plan_id = location?.state?.plan;
  const [showContractModal, setShowContractModal] = useState(false);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
 useEffect(()=>{
    dispatch(getMyEtablissement())
 },[])
  const handleLocationSelect = (place, setFieldValue, setFieldTouched) => {
    if (!place) {
      setFieldValue("numero_rue", "");
      setFieldValue("lat", null);
      setFieldValue("lng", null);
      setFieldValue("code_postal", null);
      setFieldValue("ville", null);
    } else {
      setFieldValue("numero_rue", place.description);

      if (isLoaded && window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ placeId: place.place_id }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
            const { lat: googleLat, lng: googleLng } = results[0].geometry.location;
            let city = "";
            let postalCode = "";

            results[0].address_components.forEach((component) => {
              if (component.types.includes("locality")) {
                city = component.long_name;
              }
              if (component.types.includes("postal_code")) {
                postalCode = component.long_name;
              }
            });

            setFieldValue("lat", googleLat());
            setFieldValue("lng", googleLng());
            setFieldValue("code_postal", postalCode);
            setFieldValue("ville", city);
          }
        });
      }
    }
    setFieldTouched("numero_rue", true);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await create(values, "adresses-facturation");
      localStorage.setItem(
        "adresse_facturation",
        JSON.stringify({
          ...response?.data?.adresse,
          is_default: values.saveBellingAdress,
        })
      );
      
      const stepsStatus = JSON.parse(localStorage.getItem("stepsStatus")) || {};
      stepsStatus[3] = "completed";
      if(plan_id==='libre'){
         navigate("/confirmation",{state:{etablissement:selectedEtablissement?.id}} )
      }else{
        navigate("/paiement", { state: { plan: plan_id } });
      }
    } catch (err) {
      // console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const modalContent = `https://docs.google.com/viewer?url=${encodeURIComponent(process.env.REACT_APP_CONTRAT_TWYNY)}`; // Your full modal content here

  return (
    <Formik
      initialValues={getInitialValues()}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        submitForm,
        isSubmitting,
        touched,
        errors,
        values,
        setTouched,
        setFieldValue,
        setFieldTouched,
      }) => {
        const handleFooterSubmit = () => {
          setTouched({
            numero_rue: true,
            ville: true,
            code_postal: true,
            acceptContrat: true,
          });
          submitForm();
        };

        const handleAcceptContract = () => {
          setFieldValue("acceptContrat", true);
          setShowContractModal(false);
        };

        return (
          <LayoutPro
            currentStep={3}
            nextStep="/paiement"
            handleSubmit={handleFooterSubmit}
            disabled={isSubmitting}
            nameBtnSubmit="Continuer vers le paiement"
            btn={false}
          >
            <div className="container">
              <div className="d-flex justify-content-center mt-48">
                <div className="col-md-6">
                  <h3 className="grey500">Adresse de facturation</h3>
                  <Form className="register-form mt-24">
                    {/* Numéro et nom de rue */}
                    <div className="input-wrapper mt-8">
                      <label className="form-label">Numéro et voie*</label>
                      <div className="relative">
                        <LocationAutocomplete
                          onLocationSelect={(place) =>
                            handleLocationSelect(place, setFieldValue, setFieldTouched)
                          }
                          isGoogleLoaded={isLoaded}
                          value={values.numero_rue}
                        />
                      </div>
                      <ErrorMessage name="numero_rue">
                        {(msg) => (
                          <div className="error-message mt-1">
                            <img
                              src="/images/alert-circle.svg"
                              className="arrow mr-8"
                              alt="Arrow"
                            />
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>

                    {/* Complément d'adresse */}
                    <div className="input-wrapper">
                      <label className="form-label">Complément d'adresse</label>
                      <Field
                        name="complement_adresse"
                        placeholder="Complément d'adresse"
                        className="padding-input-text"
                      />
                    </div>

                    {/* City and Postal Code */}
                    <div className="row">
                      {/* City Field */}
                      <div className="col-md-6 input-wrapper">
                        <label className="form-label block text-sm font-medium text-gray-700 mb-1">
                          Ville*
                        </label>
                        <Field
                          name="ville"
                          placeholder="Ville"
                          // readOnly={!!values.ville}
                          className={`w-full p-3 border rounded ${
                            touched.ville && errors.ville
                              ? "is-invalid border-red-500"
                              : "border-gray-300"
                          } ${values.ville ? "bg-gray-100" : ""}`}
                        />
                        <ErrorMessage name="ville">
                          {(msg) => (
                            <div className="error-message mt-1 text-red-500 text-sm">
                              {msg}
                            </div>
                          )}
                        </ErrorMessage>
                      </div>

                      {/* Postal Code Field */}
                      <div className="col-md-6 input-wrapper">
                        <label className="form-label block text-sm font-medium text-gray-700 mb-1">
                          Code postal*
                        </label>
                        <Field
                          name="code_postal"
                          // readOnly={!!values.code_postal}
                          className={`w-full p-3 border rounded ${
                            touched.code_postal && errors.code_postal
                              ? "is-invalid border-red-500"
                              : "border-gray-300"
                          } ${values.code_postal ? "bg-gray-100" : ""}`}
                          placeholder="00000"
                        />
                        <ErrorMessage name="code_postal">
                          {(msg) => (
                            <div className="error-message mt-1 text-red-500 text-sm">
                              {msg}
                            </div>
                          )}
                        </ErrorMessage>
                      </div>
                    </div>

                    {/* Save address checkbox */}
                    <Field
                      name="saveBellingAdress"
                      as={Checkbox}
                      id="save-adr"
                      label="Enregistrer l'adresse de facturation"
                      onChange={(e) =>
                        setFieldValue("saveBellingAdress", e.target.checked)
                      }
                      checked={values.saveBellingAdress}
                    />

                    {/* Contract acceptance */}
                    <div className="padding-16 badge-pre">
                      <h4 className="card-title">Contrat Twyny</h4>
                      <p className="card-text mt-8">
                        Avant de finaliser mon compte, je prends connaissance du
                        contrat d'utilisation Twyny.
                      </p>

                      <Field
                        name="acceptContrat"
                        as={Checkbox}
                        required
                        id="legal-checkbox"
                        label={
                          <>
                            En créant mon compte, j'accepte les{" "}
                            <span
                              className="link-blue no-decoration"
                              onClick={(e) => {
                                e.preventDefault();
                                // navigate(process.env.REACT_APP_CONTRAT_TWYNY)
                                // window.open(
                                //   `https://docs.google.com/viewer?url=${encodeURIComponent(process.env.REACT_APP_CONTRAT_TWYNY)}`,
                                //   "_blank"
                                // )
                                 setShowContractModal(true);
                              }}
                            >                             
                              Contrats d'utilisation Twyny
                            </span>
                          </>
                        }
                        onChange={(e) =>
                          setFieldValue("acceptContrat", e.target.checked)
                        }
                        checked={values.acceptContrat}
                      />
                      <ErrorMessage name="acceptContrat" component={ErrorMsg} />
                    </div>

                    <div className="ht-100"></div>
                  </Form>
                </div>
              </div>
            </div>
            
            <ModalTwyny
              title="Contrat d'utilisation Twyny"
              // content={modalContent}
              content={
                <iframe
                title='contrat'
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(process.env.REACT_APP_CONTRAT_TWYNY)}&embedded=true`}
                  style={{ width: '100%', height: '500px' }}
                  frameBorder="0"
                />
              }
              open={showContractModal}
              setOpen={setShowContractModal}
              Accept={handleAcceptContract}
            />
          </LayoutPro>
        );
      }}
    </Formik>
  );
}

const ErrorMsg = ({ children }) => (
  <div className="error-message mt-1">
    <img src="/images/alert-circle.svg" className="arrow mr-8" alt="Alert" />
    {children}
  </div>
);

export default BillingAddress;